module.exports = __webpack_public_path__ + "img/Tool-moving.ae4b1026.svg";